import { ROUTE_BASE_URL } from "../api/common";

// import Testing from '../components/testing';
// import Notifications from '../components/Components/Notifications';

//-----Dashboard
import EventsDashboard from "../components/Dashboard/events-dashboard";

//-----AdminUser
import AdminUsers from "../components/AdminUsers/admin-users";
import AdminUserRole from "../components/AdminUsers/role-type/role-type";
import AdminUserPermission from "../components/AdminUsers/role-permission/role-premission";
import MyProfile from "../components/AdminUsers/my-profile";
import AccessDenied from '../components/Authentication/access-denied';

//-----Common Masters
import Gst from "../components/Master/gst/gst";
import GstType from "../components/Master/gst-type/gst-type";
import PaymentStatus from "../components/Master/payment-status/payment-status";
import ReviewStatus from "../components/Master/review-status/review-status";
import Currency from "../components/Master/currency/currency";
import Country from "../components/Master/country/country";
import EventTickets from "../components/Event/Tickets/EventTickets";

//-----Settings
// import Sttings from '../components/settings/settings';

// -----Event Management
import AdminTeam from "../components/Event/EventManagement/AdminTeam";
import Overview from "../components/Event/EventManagement/Overview";
import Attendess from "../components/Event/EventManagement/Attendees";
import EventRegistration from "../components/Event/EventRegistration/EventRegistration";
import EventAttentees from "../components/Event/EventAttendees/EventAttentees";
import EventOrderPaymets from "../components/Event/EventOrderPayments/EventOrderPaymets";
import EventInfo from "../components/Event/EventInfo/EventInfo";
import DynamicForms from "../components/Event/EventDynamicForms/DynamicForms";
import EventManagement from "../components/Event/EventManagement/Event";
import Coupons from "../components/Event/Coupons/Coupons";
import Emails from "../components/Event/Emails/Emails";
import EventOverview from "../components/Event/EventOverview/EventOverview";

import Eventprofile from "../components/Event/EventProfile/Eventprofile";
import EventAddOns from "../components/Event/EventAddOns/EventAddOns";
import Settings from "../components/Event/Settings/Settings";

import PaymentSettings from "../components/Event/PaymentSettings/PaymentSettings";
import AttendeesCheckin from "../components/Event/AttendeesCheckin/AttendeesCheckin";
import RolesAndPermissions from "../components/Event/RolesAndPermissions/RolesAndPermissions";
import BadgeList from "../components/Event/Badge/BadgeList";

//-----Reports
import Reports from "../components/Event/Reports/Reports";
import Testing from "../components/testing";
import Badge from "../components/Event/Badge/Badge";
import Certificate from '../components/Event/Certificate/Certificate'
import CertficateList from '../components/Event/Certificate/CertficateList'
const Routes = [
  {
    path: `${ROUTE_BASE_URL}/`,
    name: 'dashboard',
    exact: true,
    pageTitle: 'Dashboard',
    component: EventManagement,
  },
  {
    path: `${ROUTE_BASE_URL}/test`,
    name: 'Testing',
    exact: true,
    pageTitle: 'Testing',
    component: Testing,
  },
  {
    path: `${ROUTE_BASE_URL}/create/badge`,
    name: 'Badge',
    exact: true,
    pageTitle: 'Badge',
    component: Badge,
  },
  {
    path: `${ROUTE_BASE_URL}/badge`,
    name: 'BadgeList',
    exact: true,
    pageTitle: 'BadgeList',
    component: BadgeList,
  },
  {
    path: `${ROUTE_BASE_URL}/admin-users`,
    name: 'admin-users',
    exact: true,
    pageTitle: 'Admin Users',
    component: AdminUsers,
  },
  {
    path: `${ROUTE_BASE_URL}/admin-user-role`,
    name: 'admin-user-role',
    exact: true,
    pageTitle: 'Admin User Role',
    component: AdminUserRole,
  },
  {
    path: `${ROUTE_BASE_URL}/admin-user-permission/:slug`,
    name: 'admin-user-permission',
    exact: true,
    pageTitle: 'Admin User Permission',
    component: AdminUserPermission,
  },
  {
    path: `${ROUTE_BASE_URL}/my-profile`,
    name: 'my-profile',
    exact: true,
    pageTitle: 'My Profile',
    component: MyProfile,
  },
  {
    path: `${ROUTE_BASE_URL}/country`,
    name: 'country',
    exact: true,
    pageTitle: 'country',
    component: Country,
  },
  {
    path: `${ROUTE_BASE_URL}/gst`,
    name: 'GST',
    exact: true,
    pageTitle: 'gst',
    component: Gst,
  },
  {
    path: `${ROUTE_BASE_URL}/gst-type`,
    name: 'GST Type',
    exact: true,
    pageTitle: 'gst type',
    component: GstType,
  },
  {
    path: `${ROUTE_BASE_URL}/payment-status`,
    name: 'Payment Status',
    exact: true,
    pageTitle: 'payment status',
    component: PaymentStatus,
  },
  {
    path: `${ROUTE_BASE_URL}/review-status`,
    name: 'Review Status',
    exact: true,
    pageTitle: 'review status',
    component: ReviewStatus,
  },
  {
    path: `${ROUTE_BASE_URL}/currency`,
    name: 'currency',
    exact: true,
    pageTitle: 'currency',
    component: Currency,
  },
  //event
  {
    path: `${ROUTE_BASE_URL}/event-management`,
    name: 'EventManagement',
    exact: true,
    pageTitle: 'Event Management',
    component: EventManagement,
  },
  {
    path: `${ROUTE_BASE_URL}/event-registration`,
    name: 'EventRegistration',
    exact: true,
    pageTitle: 'Event Registration',
    component: EventRegistration,
  },
  {
    path: `${ROUTE_BASE_URL}/admin-team`,
    name: 'AdminTeam',
    exact: true,
    pageTitle: 'Admin Team',
    component: AdminTeam,
  },
  {
    path: `${ROUTE_BASE_URL}/overview`,
    name: 'Overview',
    exact: true,
    pageTitle: 'Overview',
    component: Overview,
  },
  {
    path: `${ROUTE_BASE_URL}/attendess`,
    name: 'Attendess',
    exact: true,
    pageTitle: 'Attendess',
    component: Attendess,
  },
  {
    path: `${ROUTE_BASE_URL}/event-attentees`,
    name: 'EventAttentees',
    exact: true,
    pageTitle: 'Event Attentees',
    component: EventAttentees,
  },
  {
    path: `${ROUTE_BASE_URL}/event-addons`,
    name: 'EventAddons',
    exact: true,
    pageTitle: 'Event Addons',
    component: EventAddOns,
  },
  {
    path: `${ROUTE_BASE_URL}/event-tickets`,
    name: 'EventTickets',
    exact: true,
    pageTitle: 'Event Tickets',
    component: EventTickets,
  },
  {
    path: `${ROUTE_BASE_URL}/event-order-payments`,
    name: 'EventOrderPayments',
    exact: true,
    pageTitle: 'Event Order Payments',
    component: EventOrderPaymets,
  },
  {
    path: `${ROUTE_BASE_URL}/event-emails`,
    name: 'Event Emails',
    exact: true,
    pageTitle: 'Event Emails',
    component: Emails,
  },
  {
    path: `${ROUTE_BASE_URL}/event-registration-info`,
    name: 'EventInfo',
    exact: true,
    pageTitle: 'Event Info',
    component: EventInfo,
  },
  {
    path: `${ROUTE_BASE_URL}/dynamic-forms`,
    name: 'DynamicForms',
    exact: true,
    pageTitle: 'Dynamic Forms',
    component: DynamicForms,
  },
  {
    path: `${ROUTE_BASE_URL}/coupons`,
    name: 'Coupons',
    exact: true,
    pageTitle: 'Coupons',
    component: Coupons,
  },
  {
    path: `${ROUTE_BASE_URL}/event-profile1`,
    name: 'Eventprofile',
    exact: true,
    pageTitle: 'Eventprofile',
    component: Eventprofile,
  },
  {
    path: `${ROUTE_BASE_URL}/event-overview/:slug`,
    name: 'Eventoverview',
    exact: true,
    pageTitle: 'Event Overview',
    component: EventOverview,
  },
  {
    path: `${ROUTE_BASE_URL}/settings`,
    name: 'Settings',
    exact: true,
    pageTitle: 'Settings',
    component: Settings,
  },
  {
    path: `${ROUTE_BASE_URL}/payment-settings`,
    name: 'Payment Settings',
    exact: true,
    pageTitle: 'Payment Settings',
    component: PaymentSettings,
  },
  {
    path: `${ROUTE_BASE_URL}/attendees-checkin`,
    name: 'Check-in',
    exact: true,
    pageTitle: 'Check-in',
    component: AttendeesCheckin,
  },
  {
    path: `${ROUTE_BASE_URL}/my-profile`,
    name: 'my-profile',
    exact: true,
    pageTitle: 'My Profile',
    component: MyProfile,
  },
  {
    path: `${ROUTE_BASE_URL}/roles-and-permission`,
    name: 'Roles and Permission',
    exact: true,
    pageTitle: 'Roles and Permission',
    component: RolesAndPermissions,
  },
  {
    path: `${ROUTE_BASE_URL}/access-denied`,
    name: 'User Permission',
    exact: true,
    pageTitle: 'User Permission',
    component: AccessDenied,
  },
  {
    path: `${ROUTE_BASE_URL}/reports`,
    name: 'Reports',
    exact: true,
    pageTitle: 'Reports',
    component: Reports,
  },
   {
    path: `${ROUTE_BASE_URL}/certificate`,
    name: 'Reports',
    exact: true,
    pageTitle: 'Reports',
    component: Certificate,
  },
   {
    path: `${ROUTE_BASE_URL}/certificate-list`,
    name: 'Reports',
    exact: true,
    pageTitle: 'Reports',
    component: CertficateList,
  },
  {
    path: `${ROUTE_BASE_URL}/events-dashboard`,
    name: "Events Dashboard",
    exact: true,
    pageTitle: "Events Dashboard",
    component: EventsDashboard,
  },
]

export default Routes;
